import {AxiosError} from 'axios';
import {toast} from 'react-toastify';
import {useMutation} from 'react-query';

import PutLabRedesignView from '.';

interface ILabRedesignViewProps {
  onSuccess?: () => void;
}
interface AxError {
  message: string;
}
const usePutLabRedesignView = ({onSuccess}: ILabRedesignViewProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IStoreLabRedesignView) => {
      return PutLabRedesignView(payload);
    },
    onSuccess: data => {
      onSuccess && onSuccess();
    },
    onError: (data: AxiosError<AxError>) => {
      toast.error(data?.response?.data?.message || 'مشکلی پیش آمده است');
    },
  });

  return {isLoading, mutate, isSuccess};
};

export {usePutLabRedesignView};
